import { render } from "./TheAdverts.vue?vue&type=template&id=96622f52&scoped=true"
import script from "./TheAdverts.vue?vue&type=script&lang=js"
export * from "./TheAdverts.vue?vue&type=script&lang=js"

import "./TheAdverts.vue?vue&type=style&index=0&id=96622f52&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96622f52"]])

export default __exports__